<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Embed } from '#library/components.schema.build.ts'
	import { onMount } from 'svelte'

	interface Props {
		blok: Blok<Embed>
	}

	let { blok }: Props = $props()
	let container: HTMLDivElement | undefined = $state()
	let has_scripts = $state(false)

	onMount(() => {
		// Find scripts inside of blok.code and append them to the container
		const scripts = blok.code?.match(/<script[^>]*src="([^"]+)"/g)

		if (scripts) {
			has_scripts = true

			scripts.forEach(script => {
				const src_match = script.match(/src="([^"]+)"/)
				const id_match = script.match(/id="([^"]+)"/)

				if (src_match) {
					const script_el = document.createElement('script')
					script_el.src = src_match[1]
					if (id_match) script_el.id = id_match[1]

					// eslint-disable-next-line svelte/no-dom-manipulating
					container?.appendChild(script_el)
				}
			})
		}
	})
</script>

<section class="block {blok.theme}" {...attrs(blok)}>
	<div class="contain" bind:this={container}>
		{#if !has_scripts}
			{@html blok.code}
		{/if}
	</div>
</section>

<style lang="css">
	.block {
		padding-block: var(--padding-top, 0) var(--padding-bottom, 0);
	}

	.contain {
	}
</style>
